<template>
  <div class="vircos-tasks-widget">
    <div class="wg-row icons">
      <div
        v-for="(c, i) in components"
        :key="'comp-' + i"
        :class="c.id"
        @click="openDialog(c)"
        :title="c.title"
      >
        <img
          class="com-anm22-app-img-fixed-height-l"
          style="padding:5px;height:100%;"
          :src="$anm22.icons.getWorldIcon(c.icon)"
        />
        <div
          v-if="c.id == 'graphics' && project.category && project.category == 2"
          :class="[
            'widget-status',
            docs &&
            docs.graphics &&
            docs.graphics.images &&
            docs.graphics.images.length
              ? 'green'
              : 'red',
          ]"
        ></div>
        <div
          v-if="
            c.id == 'delivery' &&
              !(project.orderNumber && project.orderNumber != 0)
          "
          :class="['widget-status', 'yellow']"
          :title="
            $anm22.strLang(
              lang,
              'Project not sent to Onda',
              'Progetto non inviato a Onda'
            )
          "
        ></div>
      </div>
      <div
        @click="openProdDialog()"
        :title="$anm22.strLang(lang, 'Production view', 'Vista produzione')"
        class="sprint"
      >
        <img
          class="com-anm22-app-img-fixed-height-l"
          style="padding:5px;height:100%;"
          :src="$anm22.icons.getWorldIcon('sprint')"
        />
      </div>
    </div>
    <wg-modal
      :fullscreen="true"
      v-if="showVircosProdModal"
      @closeModal="closeProdDialog"
      :portal="true"
    >
      <div slot="body" class="prod-modal">
        <div class="com-anm22-app-text-xl prod-modal-header">
          {{
            "" + project.projectId + " " + project.name
              ? "" + project.projectId + " " + project.name
              : $anm22.strLang(lang, "Project", "Progetto senza nome")
          }}
        </div>
        <div class="production-role-box">
          <div class="subtitle">
            {{ $anm22.strLang(lang, "Role", "Ruolo") }}
          </div>
          <select
            v-model="productionRole"
            class="input-elem com-anm22-app-select role-select"
          >
            <option value="cut">{{
              $anm22.strLang(lang, "Cutting", "Taglio")
            }}</option>
            <option value="lab">{{
              $anm22.strLang(lang, "Laboratory", "Laboratorio")
            }}</option>
            <option value="finishing">{{
              $anm22.strLang(lang, "Finishing", "Finitura")
            }}</option>
          </select>
          <div
            v-if="defaultProductionRole == productionRole"
            class="default-role-btn selected"
            @click="deleteDefaultProductionRole()"
          >
            {{ $anm22.strLang(lang, "Default", "Predefinito") }}
          </div>
          <div
            v-else
            class="default-role-btn"
            @click="setDefaultProductionRole(productionRole)"
          >
            {{ $anm22.strLang(lang, "Default", "Predefinito") }}
          </div>
        </div>
        <div class="subtitle">
          {{ $anm22.strLang(lang, "Time tracking", "Monitoraggio tempo") }}
        </div>
        <div class="time-tracking">
          <template v-if="runningTask">
            <div
              v-if="runningTask.p && runningTask.p == projectId"
              class="headbar-notification-running-task running"
            >
              <img
                :src="$anm22.icons.getWorldIcon('sprint')"
                class="sprint-icon"
              />
              <div class="running-task-title">
                {{
                  $anm22.strLang(lang, "Time tracking", "Monitoraggio tempo")
                }}
              </div>
              <div class="start-time">
                <div class="time-label">
                  {{ $anm22.strLang(lang, "Start", "Inizio") }}:
                </div>
                {{ runningTaskStartTime }}
              </div>
              <div
                class="stop-btn"
                @click="timerStop()"
                :title="$anm22.strLang(lang, 'Stop', 'Stop')"
              >
                <img :src="$anm22.icons.getWorldIcon('mediaStopWhite')" />
              </div>
              <img
                :src="$anm22.icons.getWorldIcon('scanBlack')"
                class="open-scan-btn"
                @click="openScan()"
              />
            </div>
          </template>
          <template v-else>
            <div class="headbar-notification-running-task">
              <div class="running-task-title">
                {{
                  $anm22.strLang(lang, "Time tracking", "Monitoraggio tempo")
                }}
              </div>
              <div class="running-task-desc">
                {{ $anm22.strLang(lang, "Start timer", "Avvia il turno") }}
              </div>
              <div
                class="play-btn"
                @click="timerStart()"
                :title="$anm22.strLang(lang, 'Play', 'Play')"
              >
                <img :src="$anm22.icons.getWorldIcon('mediaPlayWhite')" />
              </div>
              <img
                :src="$anm22.icons.getWorldIcon('scanBlack')"
                class="open-scan-btn"
                @click="openScan()"
              />
            </div>
          </template>
        </div>
        <div
          v-if="allTasksData.length"
          class="subtitle"
          style="margin-top:15px"
        >
          {{ $anm22.strLang(lang, "Tasks", "Attività") }}
        </div>
        <div class="tasks">
          <div
            class="wg-row"
            v-for="tdata in allTasksData"
            :key="'task-' + tdata.id"
          >
            <div
              :class="
                'wg-col ' +
                  (tdata.status == 1 || tdata.status == 2
                    ? 'wg-xs-8'
                    : 'wg-xs-12')
              "
              draggable="true"
              @dragstart="dragStartTaskDone()"
            >
              <task-bar
                :taskData="tdata"
                :view="'cols'"
                @open-task="$emit('open-task', $event)"
              ></task-bar>
            </div>
            <div
              v-if="tdata.status == 1 || tdata.status == 2"
              class="wg-col wg-xs-4 task-status-done-btn"
              @click="setTaskDone(tdata.id)"
              @dragover="dragTaskDone()"
              @drop="dropTaskDone(tdata.id)"
              @dragenter.prevent
              @dragover.prevent
            >
              {{ $anm22.strLang(lang, "Done", "Completa") }}
            </div>
          </div>
        </div>
        <div class="wg-col wg-xs-12">
          <div class="subtitle" style="margin-top:15px">
            {{ $anm22.strLang(lang, "Notes", "Note") }}
          </div>
          <textarea
            v-if="productionRole == 'cut'"
            class="input-elem com-anm22-app-textarea"
            style="height:200px;width:100%;max-width:unset;"
            v-model.lazy="docs.cutting.notes"
            @change="save(docs, false)"
          ></textarea>
          <textarea
            v-if="productionRole == 'finishing'"
            class="input-elem com-anm22-app-textarea"
            style="height:200px;width:100%;max-width:unset;"
            v-model.lazy="docs.finishing.notes"
            @change="save(docs, false)"
          ></textarea>
          <textarea
            v-if="productionRole == 'lab'"
            class="input-elem com-anm22-app-textarea"
            style="height:200px;width:100%;max-width:unset;"
            v-model.lazy="docs.lab.notes"
            @change="save(docs, false)"
          ></textarea>
        </div>
        <template v-if="productionRole == 'lab'">
          <div class="wg-col wg-xs-12">
            <div class="subtitle" style="margin-top:15px">
              {{ $anm22.strLang(lang, "Production notes", "Note produzione") }}
            </div>
            <textarea
              class="input-elem com-anm22-app-textarea"
              style="height:200px;width:100%;max-width:unset;"
              v-model.lazy="docs.lab.productionNotes"
              @change="save(docs, false)"
            ></textarea>
          </div>
        </template>
        <template
          v-if="
            productionRole == 'cut' &&
              mainProjectDocs &&
              mainProjectDocs.cutting &&
              mainProjectDocs.cutting.notes
          "
        >
          <div class="wg-col wg-xs-12">
            <div class="subtitle" style="margin-top:15px">
              {{
                $anm22.strLang(
                  lang,
                  "Main project notes",
                  "Note progetto originale"
                )
              }}
            </div>
            <div>{{ mainProjectDocs.cutting.notes }}</div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
        </template>
        <!-- SHIPPING BOX TYPE -->
        <div v-if="productionRole == 'finishing'" class="wg-row input-row">
          <div class="wg-col wg-xs-12">
            <div class="subtitle">
              {{ $anm22.strLang(lang, "Shipping box", "Scatola spedizione") }}
            </div>
            <div class="wg-row input-row">
              <select
                class="input-elem com-anm22-app-select"
                v-model="docs.finishing.shippingBoxType"
                @change="save(docs, false)"
              >
                <option :value="undefined">{{
                  $anm22.strLang(lang, "Select type", "Selezione tipologia")
                }}</option>
                <option
                  v-for="(sbt, i) in shippingBoxTypes"
                  :key="'sbt-' + i"
                  :value="sbt.id"
                  >{{ sbt.label }}</option
                >
              </select>
            </div>
          </div>
        </div>
        <div class="subtitle" style="margin-top:15px">
          {{ $anm22.strLang(lang, "Design", "Disegno") }}
        </div>
        <template v-if="productionRole == 'cut' && this.docs.graphics">
          <component
            :is="'VircosGraphics'"
            :projectId="project.idWorldProject"
            :docs="docs"
            @closePrintDialog="closeDialog"
            :sizes="sizes"
            @save="save"
            :mode="'prod'"
          ></component>
        </template>
        <div
          class="graphics"
          @click="openProdGraphics()"
          :style="
            'background-image:url(' +
              $anm22.icons.getWorldIcon('tShirtBlack') +
              ')'
          "
        >
          {{
            $anm22.strLang(lang, "Open design widget", "Apri widget disegno")
          }}
        </div>
      </div>
    </wg-modal>
    <wg-modal
      :width="windowWidth > 700 ? '700px' : '90%'"
      v-if="showVircosModal"
      @closeModal="closeDialog"
      :portal="true"
    >
      <div slot="header" class="com-anm22-app-text-xl">{{ dialogTitle }}</div>
      <component
        slot="body"
        :is="selectedCustomComponent"
        :projectId="project.idWorldProject"
        :docs="docs"
        :mainProjectDocs="mainProjectDocs"
        @closePrintDialog="closeDialog"
        :sizes="sizes"
        @save="save"
      ></component>
    </wg-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TaskBar from "../../task/TaskBar.vue";

export default {
  props: {
    projectId: [Number, String],
  },
  data() {
    return {
      /* Documenti Vircos di progetto */
      docs: {
        cutting: { notes: null },
        finishing: { notes: null },
        lab: { notes: null },
        delivery: { accessories: [] },
      },
      mainProjectDocs: null,
      showVircosModal: false,
      showVircosProdModal: false,
      selectedCustomComponent: "",
      sizes: [],
      dialogTitle: "",
      selectedEvent: null,
      productionRole: "lab",
      defaultProductionRole: null,
      readerInput: "",
      // customComponentData: {}
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
      windowWidth: (state) => state.windowWidth,
      runningTask: (state) => state.headbar.runningTask,
    }),
    project() {
      return this.$store.getters["projects/get"](this.projectId);
    },
    customer() {
      if (this.project.customers.length > 0) {
        return this.$store.getters["contacts/get"](this.project.customers[0]);
      } else {
        return null;
      }
    },
    components() {
      if (this.project.category && this.project.category == 2) {
        return [
          {
            id: "data",
            title: this.$anm22.strLang(
              this.lang,
              "Project info",
              "Informazioni di progetto"
            ),
            component: "VircosData",
            icon: "list",
          },
          {
            id: "measures",
            title: this.$anm22.strLang(
              this.lang,
              "Fitting",
              "Modifiche fitting"
            ),
            component: "VircosMeasures",
            icon: "ruler",
          },
          {
            id: "graphics",
            title: this.$anm22.strLang(
              this.lang,
              "Graphics",
              "Modifiche disegno"
            ),
            component: "VircosGraphics",
            icon: "edit",
          },
          {
            id: "graphics",
            title: this.$anm22.strLang(
              this.lang,
              "Graphic design",
              "Realizzazione grafica"
            ),
            component: "VircosGraphics2",
            icon: "tShirtBlack",
          },
          {
            id: "cutting",
            title: this.$anm22.strLang(this.lang, "Cutting", "Taglio"),
            component: "VircosCutting",
            icon: "scissors",
          },
          {
            id: "lab",
            title: this.$anm22.strLang(this.lang, "Lab", "Laboratorio"),
            component: "VircosLab",
            icon: "sewingMachine",
          },
          {
            id: "finishing",
            title: this.$anm22.strLang(this.lang, "Finishing", "Finitura"),
            component: "VircosFinishing",
            icon: "stars",
          },
          {
            id: "delivery",
            title: this.$anm22.strLang(this.lang, "Delivery", "Consegna"),
            component: "VircosDelivery",
            icon: "shippingTruck",
          },
          {
            id: "print",
            title: this.$anm22.strLang(this.lang, "Recap", "Riepilogo"),
            component: "VircosDocumentPrint",
            icon: "printer",
          },
        ];
      } else {
        return [
          {
            id: "data",
            title: this.$anm22.strLang(
              this.lang,
              "Project info",
              "Informazioni di progetto"
            ),
            component: "VircosData",
            icon: "list",
          },
          {
            id: "measures",
            title: this.$anm22.strLang(
              this.lang,
              "Body measurements",
              "Misure anatomiche"
            ),
            component: "VircosMeasures",
            icon: "ruler",
          },
          {
            id: "graphics",
            title: this.$anm22.strLang(
              this.lang,
              "Drawing instructions",
              "Indicazioni disegno"
            ),
            component: "VircosGraphics",
            icon: "edit",
          },
          {
            id: "graphics",
            title: this.$anm22.strLang(
              this.lang,
              "Graphic design",
              "Realizzazione grafica"
            ),
            component: "VircosGraphics2",
            icon: "tShirtBlack",
          },
          {
            id: "measuresSheet",
            title: this.$anm22.strLang(
              this.lang,
              "Measures sheet",
              "Scheda misure"
            ),
            component: "VircosMeasuresSheet",
            icon: "menuTable",
          },
          {
            id: "materials",
            title: this.$anm22.strLang(this.lang, "Materials", "Distinta base"),
            component: "VircosMaterials",
            icon: "menuWarehouse",
          },
          {
            id: "cutting",
            title: this.$anm22.strLang(this.lang, "Cutting", "Taglio"),
            component: "VircosCutting",
            icon: "scissors",
          },
          {
            id: "lab",
            title: this.$anm22.strLang(this.lang, "Lab", "Laboratorio"),
            component: "VircosLab",
            icon: "sewingMachine",
          },
          {
            id: "finishing",
            title: this.$anm22.strLang(this.lang, "Finishing", "Finitura"),
            component: "VircosFinishing",
            icon: "stars",
          },
          {
            id: "delivery",
            title: this.$anm22.strLang(this.lang, "Delivery", "Consegna"),
            component: "VircosDelivery",
            icon: "shippingTruck",
          },
          {
            id: "qrcode",
            title: this.$anm22.strLang(this.lang, "Project QR Code", "QR Code"),
            component: "ProjectQRCode",
            icon: "qrCode",
          },
          {
            id: "print",
            title: this.$anm22.strLang(this.lang, "Recap", "Riepilogo"),
            component: "VircosDocumentPrint",
            icon: "printer",
          },
        ];
      }
    },
    runningTaskStartTime() {
      if (this.runningTask) {
        if (Date.now() - this.runningTask.st * 1000 < 86400000) {
          return this.$moment.unix(this.runningTask.st).format("HH:mm");
        } else {
          return this.$moment.unix(this.runningTask.st).format("YYYY-MM-DD");
        }
      }
    },
    allTasks() {
      return this.$store.getters["tasks/getByProject"](this.projectId).filter(
        (p) => p.jobs.includes(this.productionRole)
      );
    },
    allTasksData() {
      return this.allTasks.map((t) => {
        const data = {
          id: t.idWorldTask,
          priority: t.priority,
          name: t.name,
          users: t.users,
          status: t.status,
          startDate: t.startDate,
          fts: t.fts,
          jobs: t.jobs,
          project: t.project,
          actualEndDate: t.actualEndDate,
          expectedEndDate: t.expectedEndDate,
          deadline: t.actualEndDate || t.expectedEndDate || "",
        };
        return data;
      });
    },
    shippingBoxTypes() {
      return this.$anm22["vircos_getShippingBoxTypes"](this);
    },
  },
  methods: {
    loadData() {
      return this.$vlf("vircos-project-docs")
        .getItem(String(this.project.idWorldProject))
        .then((result) => {
          if (result) {
            // Usiamo questo componente come store per i documenti del progetto, non quello centrale
            if (!result.finishing || Array.isArray(result.finishing)) {
              result.finishing = {};
            }
            if (!result.finishing.notes) {
              result.finishing.notes = null;
            }
            if (!result.lab || Array.isArray(result.lab)) {
              result.lab = {};
            }
            if (!result.lab.notes) {
              result.lab.notes = null;
            }
            if (!result.cutting || Array.isArray(result.cutting)) {
              result.cutting = {};
            }
            if (!result.cutting.notes) {
              result.cutting.notes = null;
            }
            if (!result.delivery || Array.isArray(result.delivery)) {
              result.delivery = {};
            }
            if (typeof result.delivery.accessories == "undefined") {
              result.delivery.accessories = [];
            }

            if (!result.graphics || Array.isArray(result.graphics)) {
              result.graphics = {};
            }
            if (typeof result.graphics.color1qnt == "undefined") {
              result.graphics.color1qnt = null;
            }
            if (typeof result.graphics.color2qnt == "undefined") {
              result.graphics.color2qnt = null;
            }
            if (typeof result.graphics.color3qnt == "undefined") {
              result.graphics.color3qnt = null;
            }
            if (typeof result.graphics.color4qnt == "undefined") {
              result.graphics.color4qnt = null;
            }
            if (typeof result.graphics.color5qnt == "undefined") {
              result.graphics.color5qnt = null;
            }
            if (typeof result.graphics.color6qnt == "undefined") {
              result.graphics.color6qnt = null;
            }

            this.docs = result;

            // Main project data
            if (result.data.mainProjectId) {
              this.$vlf("vircos-project-docs")
                .getItem(String(result.data.mainProjectId))
                .then((result) => {
                  if (result) {
                    // Usiamo questo componente come store per i documenti del progetto, non quello centrale
                    if (!result.finishing || Array.isArray(result.finishing)) {
                      result.finishing = {};
                    }
                    if (!result.finishing.notes) {
                      result.finishing.notes = null;
                    }
                    if (!result.lab || Array.isArray(result.lab)) {
                      result.lab = {};
                    }
                    if (!result.lab.notes) {
                      result.lab.notes = null;
                    }
                    if (!result.cutting || Array.isArray(result.cutting)) {
                      result.cutting = {};
                    }
                    if (!result.cutting.notes) {
                      result.cutting.notes = null;
                    }
                    if (!result.delivery || Array.isArray(result.delivery)) {
                      result.delivery = {};
                    }
                    if (typeof result.delivery.accessories == "undefined") {
                      result.delivery.accessories = [];
                    }

                    if (!result.graphics || Array.isArray(result.graphics)) {
                      result.graphics = {};
                    }
                    if (typeof result.graphics.color1qnt == "undefined") {
                      result.graphics.color1qnt = null;
                    }
                    if (typeof result.graphics.color2qnt == "undefined") {
                      result.graphics.color2qnt = null;
                    }
                    if (typeof result.graphics.color3qnt == "undefined") {
                      result.graphics.color3qnt = null;
                    }
                    if (typeof result.graphics.color4qnt == "undefined") {
                      result.graphics.color4qnt = null;
                    }
                    if (typeof result.graphics.color5qnt == "undefined") {
                      result.graphics.color5qnt = null;
                    }
                    if (typeof result.graphics.color6qnt == "undefined") {
                      result.graphics.color6qnt = null;
                    }

                    this.mainProjectDocs = result;
                  }
                });
            }
          }
        });
    },
    //Carico tutte le taglie
    loadSizes() {
      return this.$vlf("vircos-models-base")
        .getItems()
        .then((result) => {
          if (result) {
            this.sizes = Object.values(result);
          }
        });
    },
    save(docs, canUpdate) {
      /* viene ricaricato anche il progetto contestualmente al salvataggio */
      this.$http
        .post(
          "vircos",
          {
            projectId: this.project.idWorldProject,
            docs: docs,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          Promise.all([
            this.$vlf("vircos-project-docs").setItem(
              String(response.data.docs.project),
              response.data.docs
            ),
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: response.data.projects,
            }),
          ])
            .then(() => {
              return this.loadData();
            })
            .then(() => this.updateProject(canUpdate));
        })
        .catch((error) => {
          /* offline */
        });
    },
    updateProject(canUpdate) {
      const project = { ...this.project };
      let canUpdateCode = false;
      if (typeof canUpdate != "undefined") {
        canUpdateCode = canUpdate;
      }
      if (this.customer) {
        /* ----------------- PROJECT CODE --------------------------------------------------------------- */
        const year = this.$moment
          .unix(this.project.startDate + 86400 * 32)
          .utc()
          .format("YY");
        if (this.project.category && this.project.category == 2) {
          /* Codice progetto riparazione */

          /* Calcolo progressivo annuale progetti (inizio da dicembre), utilizza il campo creationDate e il cliente per il progressivo */
          const progressive =
            this.$store.getters["projects/getAllByWork"](16).filter(
              (p) =>
                this.docs &&
                this.docs.data &&
                p.projectId.startsWith(this.docs.data.mainProject) &&
                p.creationDate < this.project.creationDate &&
                p.category == this.project.category
            ).length + 1;
          /* Costruzione del nome progetto */
          if (canUpdateCode) {
            let projectCode = "";
            if (this.docs && this.docs.data && this.docs.data.mainProject) {
              projectCode = this.docs.data.mainProject + " ";
            }
            projectCode += "R-";
            projectCode += String(progressive);
            project.projectId = projectCode;
          }
        } else {
          /* Codice progetto nuova tuta */

          /* Calcolo progressivo annuale progetti (inizio da dicembre), utilizza il campo creationDate e il cliente per il progressivo */
          const progressive =
            this.$store.getters["projects/getAllByWork"](16).filter(
              (p) =>
                this.$moment
                  .unix(p.startDate)
                  .utc()
                  .format("YY") === year &&
                p.customers.includes(this.customer.idContactsContact) &&
                !p.deleted &&
                p.idWorldProject != project.idWorldProject &&
                p.category != 2
              //p.creationDate < this.project.creationDate &&
            ).length + 1;
          /* Costruzione del nome progetto */
          if (canUpdateCode) {
            let projectCode = "";
            if (this.docs.data.company) {
              projectCode +=
                (this.docs.data.company !== "others"
                  ? this.docs.data.company.toUpperCase()
                  : this.docs.data.companyName.toUpperCase()) + " ";
            }
            projectCode +=
              this.docs.data.name.substring(0, 3).toUpperCase() + " ";
            projectCode +=
              this.docs.data.surname.substring(0, 3).toUpperCase() + " ";
            projectCode += year + " ";
            projectCode += String(progressive).padStart(3, "0");
            project.projectId = projectCode;
          }
        }
      }
      /* ------------------------ PROJECT END DATE -------------------------------------------- */
      if (this.docs.delivery && this.docs.delivery.deliveryDate) {
        project.endDate = this.docs.delivery.deliveryDate;
      }
      return this.$http
        .post(
          "project/edit",
          { project },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          //Salvo con localForage
          return this.$store.dispatch("projects/update", {
            vlf: this.$vlf("projects"),
            objs: response.data.projects,
          });
        });
    },
    openDialog(obj) {
      this.dialogTitle = obj.title;
      this.selectedCustomComponent = obj.component;
      this.showVircosModal = true;
    },
    closeDialog() {
      this.showVircosModal = false;
      this.customComponentData = {};
      this.loadData();
    },
    openProdDialog() {
      this.showVircosProdModal = true;
    },
    closeProdDialog() {
      this.showVircosProdModal = false;
    },
    openProdGraphics() {
      this.openDialog({
        id: "graphics",
        title: this.$anm22.strLang(
          this.lang,
          "Graphics",
          "Indicazioni disegno"
        ),
        component: "VircosGraphics",
        icon: "tShirtBlack",
      });
    },
    openProdMaterialsList() {
      this.openDialog({
        id: "materials",
        title: this.$anm22.strLang(this.lang, "Materials", "Distinta base"),
        component: "VircosMaterials",
        icon: "menuWarehouse",
      });
    },
    addEventByStartTime(start, projectId) {
      const end = this.$moment();

      /* Creo un nuovo evento fittizio, inserimento vero e proprio solo alla pressione del tasto salva */
      let event = {
        name: "",
        startTimestamp: start,
        endTimestamp: end.unix(),
        timezone: this.project.timezone || "Europe/Rome",
        type: 1,
        creator: this.user.idWorldUser,
        tempTimeTracking: true,
      };

      //Creazione nuovo evento
      this.selectedEvent = event;

      // Set additional data
      // event.jsonData = JSON.stringify(this.additionalData);

      let add = true;
      event.dbKey = event.idWorldEvent = this.$anm22.genLocalId();

      // Gestisco flag richiesta cancellazione tracking tempo
      if (event.tempTimeTracking) {
        this.removeTempTimeTracking = true;
        delete event.tempTimeTracking;
      } else {
        this.removeTempTimeTracking = false;
      }

      this.$http
        .post(
          "event/save",
          {
            projectId: projectId,
            event: event,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          //Salvo in db locale i nuovi dati
          let project = this.$store.getters["projects/get"](projectId);
          if (add) {
            project.events.push(response.data.event.idWorldEvent);
          }
          return Promise.all([
            this.$store.dispatch("events/update", {
              vlf: this.$vlf("events"),
              objs: [response.data.event],
            }),
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: [project],
            }),
          ]);
        })
        .then(() => {
          // Cancello monitoraggio in corso
          this.$store.commit("headbar/runningTask", null);
          this.$anm22.setCookie("tk_r_t", null, 1);
        })
        .catch((error) => {
          const project = this.$store.getters["projects/get"](projectId);
          if (add) {
            project.events.push(event.idWorldEvent);
          }
          Promise.all([
            this.$store.dispatch("events/update", {
              vlf: this.$vlf("events"),
              objs: [event],
            }),
            this.$store.dispatch("offline/saveSyncTuple", {
              _vue: this,
              _class: "WorldEvent",
              _table: "events",
              mode: add ? "new" : "edit",
              type: "obj",
              obj: event,
            }),
            // this.$anm22.saveSyncTuple(
            //   this,
            //   "WorldEvent",
            //   add ? 'new' : 'edit',
            //   event
            // ),
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: [project],
            }),
            this.$store.dispatch("offline/saveSyncTuple", {
              _vue: this,
              _class: "WorldProject",
              _table: "projects",
              mode: "edit",
              type: "obj",
              obj: project,
            }),
            // this.$anm22.saveSyncTuple(
            //   this,
            //   "WorldProject",
            //   'edit',
            //   project
            // )
          ]).catch((error) => {
            console.log(error);
          });
        });
    },
    timerStart() {
      const runningTask = {
        p: this.projectId,
        pn: this.project.name,
        st: Math.round(Date.now() / 1000),
      };
      this.$store.commit("headbar/runningTask", runningTask);
      this.$anm22.setCookie("tk_r_t", JSON.stringify(runningTask), 31536000);
    },
    timerStop() {
      this.deleteRunningTask = true;
      this.addEventByStartTime(this.runningTask.st, this.projectId);
    },
    setDefaultProductionRole(role) {
      this.defaultProductionRole = role;
      this.$anm22.setCookie("vircos_prod_role", role, 31536000);
    },
    deleteDefaultProductionRole() {
      this.defaultProductionRole = null;
      this.$anm22.setCookie("vircos_prod_role", null, 1);
    },
    dragStartTaskDone() {},
    dragTaskDone() {},
    dropTaskDone(taskId) {
      this.changeStatus(taskId, 3);
    },
    setTaskDone(taskId) {
      this.changeStatus(taskId, 3);
    },
    async changeStatus(taskId, statusId) {
      let callback = async () => {};

      let task = this.$store.getters["tasks/get"](taskId);
      const old = task.status;

      let project = this.$store.getters["projects/get"](task.project);
      const tasks = this.$store.getters["tasks/getByProject"](
        project.idWorldProject
      );

      task.status = statusId;
      // Se il task passa da in attesa a in corso o completato e non ho alcuno sviluppatore, metto me stesso
      if (
        old === 1 &&
        (task.status === 2 || task.status === 3) &&
        task.users.length === 0
      ) {
        // task.users.push(this.user.idWorldUser);
        callback = async () =>
          await this.addUser(taskId, this.user.idWorldUser);
      }
      //Task completato, inserisco la data di consegna se non è già presente
      if (task.status === 3 && task.actualEndDate === "") {
        task.actualEndDate = this.$moment.utc().unix();
      }
      // Se il task viene messo in corso o completato e non c'è una data di inizio impostata, la applico
      if ((task.status === 2 || task.status === 3) && task.startDate === "") {
        task.startDate = this.$moment.utc().unix();
      }

      // Salvataggio
      let waiting = true,
        complete = true;

      tasks.concat([task]).forEach((t) => {
        if (t.status !== 1) {
          waiting = false;
        }
        if (t.status !== 3) {
          complete = false;
        }
      });
      if (!waiting) {
        project.status = 2;
      }
      if (complete) {
        project.status = 3;
      }
      try {
        const response = await this.$http.post(
          "task/edit",
          {
            projectId: task.project,
            projectStatus: project.status,
            task: task,
          },
          {
            withCredentials: true,
          }
        );
      } catch (e) {
        console.log(e);
      } finally {
        if (typeof callback === "function") {
          await callback();
        }
      }
    },
    async addUser(taskId, userId) {
      let task = this.$store.getters["tasks/get"](taskId);

      try {
        const response = await this.$http.post(
          "task/addUser",
          {
            projectId: task.project,
            taskId: task.idWorldTask,
            userId: userId,
          },
          {
            withCredentials: true,
          }
        );
        Promise.all([
          this.$store.dispatch("tasks/update", {
            vlf: this.$vlf("tasks"),
            objs: response.data.tasks,
          }),
          this.$store.dispatch("users/update", {
            vlf: this.$vlf("users"),
            objs: response.data.users,
          }),
        ]);
        if (!this.project.users.includes(userId)) {
          const project = { ...this.project };
          project.users.push(userId);
          this.$store.dispatch("projects/update", {
            vlf: this.$vlf("projects"),
            objs: [project],
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    openScan() {
      location.href =
        "https://www.anm22.it/app/scan/?cb=" +
        encodeURI("javascript:history.back()");
    },
    handleKeyPress(event) {
      if (event.key === "Enter") {
        let index = this.readerInput.indexOf("https://");
        if (index !== -1) {
          let cleanedString = this.readerInput.substring(index);
          this.processQRCode(cleanedString);
        }
        this.readerInput = "";
      } else {
        this.readerInput += event.key;
      }
    },
    processQRCode(qrCode) {
      console.log("QR Code URL:", qrCode);

      // Get project Id by URL
      qrCode = qrCode.replace("https://anm22.it/?tkice=", "");
      qrCode = qrCode.replace("https://tasks.anm22.it/project/", "");
      qrCode = qrCode.replace("?qr=1", "");
      const projectId = qrCode;

      if (this.runningTask && projectId != this.projectId) {
        this.deleteRunningTask = true;
        this.addEventByStartTime(this.runningTask.st, this.runningTask.p);
      }

      if (projectId != this.projectId) {
        this.$router.push({
          path: "/project/" + projectId + "?qr=1",
        });
      }
    },
  },
  mounted() {
    window.addEventListener("keypress", this.handleKeyPress);
  },
  beforeDestroy() {
    window.removeEventListener("keypress", this.handleKeyPress);
  },
  created() {
    this.loadSizes();
    this.loadData();
    this.$http
      .get("vircos?projectId=" + this.project.idWorldProject)
      .then((response) => {
        this.$vlf("vircos-project-docs")
          .setItem(String(response.data.docs.project), response.data.docs)
          .then((result) => {
            this.loadData();
          })
          .catch((error) => {
            console.log(error);
          });
        if (response.data.mainProjectDocs) {
          this.$vlf("vircos-project-docs")
            .setItem(
              String(response.data.mainProjectDocs.project),
              response.data.mainProjectDocs
            )
            .then((result) => {
              this.loadData();
            })
            .catch((error) => {
              console.log(error);
            });
        }
        response.data.models.map((model) =>
          this.$vlf("vircos-models-base").setItem(
            String(model.idVircosModelsBase),
            model
          )
        );
        this.loadSizes();
      })
      .catch((error) => {});
    if (this.$anm22.getCookie("vircos_prod_role")) {
      this.defaultProductionRole = this.$anm22.getCookie("vircos_prod_role");
      this.productionRole = this.defaultProductionRole;
      this.showVircosProdModal = true;

      if (
        !this.$anm22.getCookie("tk_r_t") &&
        this.defaultProductionRole &&
        this.$route.query &&
        this.$route.query.qr
      ) {
        this.timerStart();
      }
    }
  },
  components: {
    ProjectQRCode: () =>
      import(/* webpackChunkName: "custom-16" */ "./ProjectQRCode.vue"),
    VircosData: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosData.vue"),
    VircosMeasures: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosMeasures.vue"),
    VircosGraphics: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosGraphics.vue"),
    VircosGraphics2: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosGraphics2.vue"),
    VircosMaterials: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosMaterials.vue"),
    VircosMeasuresSheet: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosMeasuresSheet.vue"),
    VircosDelivery: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosDelivery.vue"),
    VircosCutting: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosCutting.vue"),
    VircosLab: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosLab.vue"),
    VircosFinishing: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosFinishing.vue"),
    VircosDocumentPrint: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosDocumentPrint.vue"),
    TaskBar,
  },
};
</script>

<style lang="scss" scoped>
.vircos-tasks-widget .icons {
  align-items: center;
  font-size: 0;
  padding: 5px 0 0 0;
  flex-wrap: nowrap;
  user-select: none;

  div {
    border-radius: 30px;
    width: 60px;
    height: 60px;
    background-color: #ddd;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 40px 40px;
    padding: 10px;
    margin: 5px 10px;
    cursor: pointer;
    position: relative;

    &:hover {
      background-color: #ccc;
    }

    &.sprint {
      background-color: #ffe57f;

      &:hover {
        background-color: #ffd740;
      }
    }

    .widget-status {
      position: absolute;
      bottom: 0px;
      right: 0px;
      width: 14px;
      height: 14px;
      border-radius: 7px;
      background-color: #f00;
      border: 0;
      padding: 0;
      margin: 0;

      &.green {
        background-color: #0f0;
      }
      &.yellow {
        background-color: #ffd740;
      }
    }
  }
}
// .vircos-tasks-widget .icons div.data {
// }
// .vircos-tasks-widget .icons div.graphics {
// }
// .vircos-tasks-widget .icons div.measure {
// }
// .vircos-tasks-widget .icons div.qrcode {
// }

.prod-modal {
  max-width: 700px;
  margin: 0 auto;

  .prod-modal-header {
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 30px;
  }

  .project-title {
    font-size: 16px;
  }

  .subtitle {
    font-weight: 700;
    text-transform: uppercase;
    color: #888;
    font-size: 14px;
    margin-bottom: 5px;
  }

  .production-role-box {
    margin-bottom: 15px;

    .role-select {
      display: inline-block;
      margin-right: 10px;
    }

    .default-role-btn {
      display: inline-block;
      color: #666;
      border: 1px solid #666;
      border-radius: 4px;
      padding: 2px 4px;
      cursor: pointer;

      &.selected {
        background-color: #666;
        color: #fff;
      }
    }
  }

  .headbar-notification-running-task {
    position: relative;
    width: calc(100% - 40px);
    height: 52px;
    background-color: #eee;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 5px 0;
    margin: 0;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10+ */
    user-select: none;

    .sprint-icon {
      position: absolute;
      left: 15px;
      top: 10px;
      width: 30px;
      opacity: 0.6;
    }
    .running-task-title {
      position: absolute;
      left: 60px;
      top: 10px;
      font-size: 10px;
      font-weight: bold;
      color: #666;
      text-transform: uppercase;
    }
    .running-task-desc {
      position: absolute;
      left: 60px;
      top: 25px;
      font-size: 14px;
    }
    .start-time {
      position: absolute;
      left: 60px;
      top: 20px;
      font-size: 22px;
      .time-label {
        font-size: 10px;
        display: inline-block;
        text-align: bottom;
        margin-right: 5px;
      }
    }
    .play-btn,
    .stop-btn {
      position: absolute;
      top: 5px;
      width: 40px;
      height: 40px;
      border-radius: 20px;
      box-sizing: border-box;
      padding: 5px;
      background-color: #ccc;
      cursor: pointer;

      img {
        opacity: 0.6;
        width: 30px;
        height: 30px;
      }
    }
    .play-btn {
      left: 10px;
      background-color: #01d479;

      img {
        opacity: 1;
      }
    }
    .stop-btn {
      right: 10px;
      background-color: #f00;

      img {
        opacity: 1;
      }
    }
    .open-scan-btn {
      display: block;
      position: absolute;
      top: 10px;
      right: -40px;
      cursor: pointer;
      width: 30px;
      height: 30px;
    }

    @media only screen and (max-device-width: 500px) {
      &.running {
        .sprint-icon {
          display: none;
        }

        .running-task-title,
        .running-task-desc,
        .start-time {
          left: 10px;
        }
      }
    }
  }

  .tasks {
    margin: 10px 0;

    .task-status-done-btn {
      border-radius: 0 8px 8px 0;
      background-image: linear-gradient(
        to right,
        rgba(1, 212, 121, 0.1),
        rgba(1, 212, 121, 1)
      );
      text-align: center;
      height: 36px;
      padding-top: 10px;
      cursor: pointer;
      user-select: none;
    }
  }

  .warehouse,
  .graphics {
    background-color: #eee;
    border: 1px solid #ddd;
    border-radius: 10px;
    font-size: 14px;
    padding: 10px 10px 10px 50px;
    margin-top: 10px;
    background-position: 17px center;
    background-repeat: no-repeat;
    background-size: 15px;
    cursor: pointer;
  }
}
</style>
